import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import appSlice from 'redux/slices/app.slice';
import useElementResize from 'hooks/useElementResize';
import { SContent, SLayoutWrapper, SMainContent } from './Layout.styles';
import ScrollToTop from '../ScrollToTop';

const Layout = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const { height: headerHeight } = useElementResize({
    ref: headerRef,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(appSlice.actions.setHeaderHeight(headerHeight));
  }, [headerHeight]);

  return (
    <SLayoutWrapper>
      <SContent $headerHeight={headerHeight}>
        <SMainContent justify="center">
          <Outlet />
        </SMainContent>
      </SContent>
      <ScrollToTop />
    </SLayoutWrapper>
  );
};

export default Layout;
